import {defineMessages} from 'react-intl'

export const mexicoStateMessages = defineMessages({
    'state.mx.aguascalientes': {
        id: 'state.mx.aguascalientes',
        defaultMessage: 'Aguascalientes'
    },
    'state.mx.bajacalifornia': {
        id: 'state.mx.bajacalifornia',
        defaultMessage: 'Baja California'
    },
    'state.mx.bajacaliforniasur': {
        id: 'state.mx.bajacaliforniasur',
        defaultMessage: 'Baja California Sur'
    },
    'state.mx.campeche': {
        id: 'state.mx.campeche',
        defaultMessage: 'Campeche'
    },
    'state.mx.chiapas': {
        id: 'state.mx.chiapas',
        defaultMessage: 'Chiapas'
    },
    'state.mx.chihuahua': {
        id: 'state.mx.chihuahua',
        defaultMessage: 'Chihuahua'
    },
    'state.mx.coahuila': {
        id: 'state.mx.coahuila',
        defaultMessage: 'Coahuila'
    },
    'state.mx.colima': {
        id: 'state.mx.colima',
        defaultMessage: 'Colima'
    },
    'state.mx.distritofederal': {
        id: 'state.mx.distritofederal',
        defaultMessage: 'Distrito Federal'
    },
    'state.mx.durango': {
        id: 'state.mx.durango',
        defaultMessage: 'Durango'
    },
    'state.mx.guanajuato': {
        id: 'state.mx.guanajuato',
        defaultMessage: 'Guanajuato'
    },
    'state.mx.guerrero': {
        id: 'state.mx.guerrero',
        defaultMessage: 'Guerrero'
    },
    'state.mx.hidalgo': {
        id: 'state.mx.hidalgo',
        defaultMessage: 'Hidalgo'
    },
    'state.mx.jalisco': {
        id: 'state.mx.jalisco',
        defaultMessage: 'Jalisco'
    },
    'state.mx.mexico': {
        id: 'state.mx.mexico',
        defaultMessage: 'México'
    },
    'state.mx.michoacan': {
        id: 'state.mx.michoacan',
        defaultMessage: 'Michoacán'
    },
    'state.mx.morelos': {
        id: 'state.mx.morelos',
        defaultMessage: 'Morelos'
    },
    'state.mx.nayarit': {
        id: 'state.mx.nayarit',
        defaultMessage: 'Nayarit'
    },
    'state.mx.nuevoleon': {
        id: 'state.mx.nuevoleon',
        defaultMessage: 'Nuevo León'
    },
    'state.mx.oaxaca': {
        id: 'state.mx.oaxaca',
        defaultMessage: 'Oaxaca'
    },
    'state.mx.puebla': {
        id: 'state.mx.puebla',
        defaultMessage: 'Puebla'
    },
    'state.mx.queretaro': {
        id: 'state.mx.queretaro',
        defaultMessage: 'Querétaro'
    },
    'state.mx.quintanaroo': {
        id: 'state.mx.quintanaroo',
        defaultMessage: 'Quintana Roo'
    },
    'state.mx.sanluispotosi': {
        id: 'state.mx.sanluispotosi',
        defaultMessage: 'San Luis Potosí'
    },
    'state.mx.sinaloa': {
        id: 'state.mx.sinaloa',
        defaultMessage: 'Sinaloa'
    },
    'state.mx.sonora': {
        id: 'state.mx.sonora',
        defaultMessage: 'Sonora'
    },
    'state.mx.tabasco': {
        id: 'state.mx.tabasco',
        defaultMessage: 'Tabasco'
    },
    'state.mx.tamaulipas': {
        id: 'state.mx.tamaulipas',
        defaultMessage: 'Tamaulipas'
    },
    'state.mx.tlaxcala': {
        id: 'state.mx.tlaxcala',
        defaultMessage: 'Tlaxcala'
    },
    'state.mx.veracruz': {
        id: 'state.mx.veracruz',
        defaultMessage: 'Veracruz'
    },
    'state.mx.yucatan': {
        id: 'state.mx.yucatan',
        defaultMessage: 'Yucatán'
    },
    'state.mx.zacatecas': {
        id: 'state.mx.zacatecas',
        defaultMessage: 'Zacatecas'
    }
})

export const mexicoStateOptions = [
    {value: 'AGU', label: 'state.mx.aguascalientes'},
    {value: 'BCN', label: 'state.mx.bajacalifornia'},
    {value: 'BCS', label: 'state.mx.bajacaliforniasur'},
    {value: 'CAM', label: 'state.mx.campeche'},
    {value: 'CHP', label: 'state.mx.chiapas'},
    {value: 'CHH', label: 'state.mx.chihuahua'},
    {value: 'COA', label: 'state.mx.coahuila'},
    {value: 'COL', label: 'state.mx.colima'},
    {value: 'CMX', label: 'state.mx.distritofederal'},
    {value: 'DUR', label: 'state.mx.durango'},
    {value: 'GUA', label: 'state.mx.guanajuato'},
    {value: 'GRO', label: 'state.mx.guerrero'},
    {value: 'HID', label: 'state.mx.hidalgo'},
    {value: 'JAL', label: 'state.mx.jalisco'},
    {value: 'MEX', label: 'state.mx.mexico'},
    {value: 'MIC', label: 'state.mx.michoacan'},
    {value: 'MOR', label: 'state.mx.morelos'},
    {value: 'NAY', label: 'state.mx.nayarit'},
    {value: 'NLE', label: 'state.mx.nuevoleon'},
    {value: 'OAX', label: 'state.mx.oaxaca'},
    {value: 'PUE', label: 'state.mx.puebla'},
    {value: 'QUE', label: 'state.mx.queretaro'},
    {value: 'ROO', label: 'state.mx.quintanaroo'},
    {value: 'SLP', label: 'state.mx.sanluispotosi'},
    {value: 'SIN', label: 'state.mx.sinaloa'},
    {value: 'SON', label: 'state.mx.sonora'},
    {value: 'TAB', label: 'state.mx.tabasco'},
    {value: 'TAM', label: 'state.mx.tamaulipas'},
    {value: 'TLA', label: 'state.mx.tlaxcala'},
    {value: 'VER', label: 'state.mx.veracruz'},
    {value: 'YUC', label: 'state.mx.yucatan'},
    {value: 'ZAC', label: 'state.mx.zacatecas'}
]

// Source - https://en.wikipedia.org/wiki/Template:Mexico_State-Abbreviation_Codes
export const stateCodeMapping = {
    'Ags.': 'AGU',
    'B.C.': 'BCN',
    'B.C.S.': 'BCS',
    'Camp.': 'CAM',
    'Chis.': 'CHP',
    'Chih.': 'CHH',
    'Coah.': 'COA',
    'Col.': 'COL',
    // eslint-disable-next-line prettier/prettier
    'CDMX': 'CMX',
    'Dgo.': 'DUR',
    'Gto.': 'GUA',
    'Gro.': 'GRO',
    'Hgo.': 'HID',
    'Jal.': 'JAL',
    'Edomex.': 'MEX',
    'Méx.': 'MEX',
    'Mich.': 'MIC',
    'Mor.': 'MOR',
    'Nay.': 'NAY',
    'N.L.': 'NLE',
    'Oax.': 'OAX',
    'Pue.': 'PUE',
    'Qro.': 'QUE',
    'Q. Roo.': 'ROO',
    'Q.R.': 'ROO',
    'S.L.P.': 'SLP',
    'Sin.': 'SIN',
    'Son.': 'SON',
    'Tab.': 'TAB',
    'Tamps.': 'TAM',
    'Tlax.': 'TLA',
    'Ver.': 'VER',
    'Yuc.': 'YUC',
    'Zac.': 'ZAC'
}
